var map = {
	"./account/account.module": [
		"../../../../../src/app/admin/account/account.module.ts",
		"common",
		"account.module"
	],
	"./admin/admin.module": [
		"../../../../../src/app/admin/admin.module.ts",
		"admin.module"
	],
	"./branches/branches.module": [
		"../../../../../src/app/admin/branches/branches.module.ts",
		"common",
		"branches.module"
	],
	"./catalog/catalog.module": [
		"../../../../../src/app/admin/studies/catalog/catalog.module.ts",
		"common",
		"catalog.module"
	],
	"./categories/categories.module": [
		"../../../../../src/app/admin/studies/categories/categories.module.ts",
		"common",
		"categories.module"
	],
	"./dashboard/dashboard.module": [
		"../../../../../src/app/dashboard/dashboard.module.ts",
		"common",
		"dashboard.module"
	],
	"./discounts/discounts.module": [
		"../../../../../src/app/admin/discounts/discounts.module.ts",
		"common",
		"discounts.module"
	],
	"./external-companies/companies.module": [
		"../../../../../src/app/external-companies/companies.module.ts",
		"common",
		"companies.module"
	],
	"./external-doctors/doctors.module": [
		"../../../../../src/app/external-doctors/doctors.module.ts",
		"common",
		"doctors.module"
	],
	"./inventory/inventory.module": [
		"../../../../../src/app/admin/inventory/inventory.module.ts",
		"common",
		"inventory.module"
	],
	"./labs/labs.module": [
		"../../../../../src/app/admin/studies/labs/labs.module.ts",
		"common",
		"labs.module"
	],
	"./patients/patients.module": [
		"../../../../../src/app/patients/patients.module.ts",
		"common",
		"patients.module"
	],
	"./prerequisites/prerequisites.module": [
		"../../../../../src/app/admin/studies/prerequisites/prerequisites.module.ts",
		"common",
		"prerequisites.module"
	],
	"./profile/profile.module": [
		"../../../../../src/app/profile/profile.module.ts",
		"common",
		"profile.module"
	],
	"./samples/samples.module": [
		"../../../../../src/app/admin/studies/samples/samples.module.ts",
		"common",
		"samples.module"
	],
	"./session/session.module": [
		"../../../../../src/app/session/session.module.ts",
		"common",
		"session.module"
	],
	"./studies/studies.module": [
		"../../../../../src/app/admin/studies/studies.module.ts",
		"studies.module"
	],
	"./users/users.module": [
		"../../../../../src/app/admin/users/users.module.ts",
		"common",
		"users.module"
	],
	"./works/works.module": [
		"../../../../../src/app/works/works.module.ts",
		"common",
		"works.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "../../../../../src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// /Users/cricketmon/Sites/clubsandwichadmin/src/$$_lazy_route_resource lazy
// module id = ../../../../../src/$$_lazy_route_resource lazy recursive
// module chunks = main